"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lightColor = {
    'primary.50': '#FEE2E9',
    'primary.100': '#FEC5D4',
    'primary.200': '#FC8AA8',
    'primary.300': '#FB638B',
    'primary.400': '#FA3C6E',
    'primary.500': '#E13663',
    'primary.600': '#AF2A4D',
    'primary.700': '#7D1E37',
    'secondary.100': '#B3B3CB',
    'secondary.200': '#666696',
    'secondary.300': '#333373',
    'secondary.400': '#000050',
    'secondary.500': '#000040',
    'secondary.600': '#000030',
    'secondary.700': '#000020',
    'black.0': '#FFFFFF',
    'black.50': '#FCFCFC',
    'black.100': '#F5F5F5',
    'black.200': '#EEEEEE',
    'black.300': '#A3A3A3',
    'black.400': '#6C6C6C',
    'black.500': '#474747',
    'black.600': '#393939',
    'black.700': '#2B2B2B',
    'black.800': '#1C1C1C',
    'black.900': '#000000',
    'green.100': '#CEF2E0',
    'green.200': '#86E0B2',
    'green.300': '#3DCD84',
    'green.400': '#0CC065',
    'green.500': '#0A9A51',
    'green.600': '#07733D',
    'green.700': '#054D28',
    'red.400': '#DF1642',
    'red.500': '#B21235',
    'red.600': '#860D28',
    'red.700': '#59091A',
    'yellow.400': '#FF8A00',
    'yellow.500': '#E67C00',
    'yellow.600': '#B36100',
    'yellow.700': '#804500',
};
var darkColor = {
    'primary.50': '#FEE2E9',
    'primary.100': '#FEC5D4',
    'primary.200': '#FC8AA8',
    'primary.300': '#FB638B',
    'primary.400': '#FA3C6E',
    'primary.500': '#E13663',
    'primary.600': '#AF2A4D',
    'primary.700': '#7D1E37',
    'secondary.100': '#B3B3CB',
    'secondary.200': '#666696',
    'secondary.300': '#333373',
    'secondary.400': '#000050',
    'secondary.500': '#000040',
    'secondary.600': '#000030',
    'secondary.700': '#000020',
    'black.0': '#FFFFFF',
    'black.50': '#FCFCFC',
    'black.100': '#F5F5F5',
    'black.200': '#EEEEEE',
    'black.300': '#A3A3A3',
    'black.400': '#6C6C6C',
    'black.500': '#474747',
    'black.600': '#393939',
    'black.700': '#2B2B2B',
    'black.800': '#1C1C1C',
    'black.900': '#000000',
    'green.100': '#CEF2E0',
    'green.200': '#86E0B2',
    'green.300': '#3DCD84',
    'green.400': '#0CC065',
    'green.500': '#0A9A51',
    'green.600': '#07733D',
    'green.700': '#054D28',
    'red.100': '#F2A2B3',
    'red.200': '#EC738E',
    'red.300': '#E54568',
    'red.400': '#DF1642',
    'red.500': '#B21235',
    'red.600': '#860D28',
    'red.700': '#59091A',
    'yellow.100': '#FFDCB3',
    'yellow.200': '#f9ba6d',
    'yellow.300': '#FFA133',
    'yellow.400': '#FF8A00',
    'yellow.500': '#E67C00',
    'yellow.600': '#B36100',
    'yellow.700': '#804500',
};
exports.default = {
    light: lightColor,
    dark: darkColor,
};
